import {all, fork, put, takeLatest} from "redux-saga/effects";
import {
  createSubscriptionSuccess,
  deleteSubscriptionSuccess,
  getAllSubscriptionsSuccess,
  getSubscriptionSuccess,
  updateSubscriptionSuccess
} from "redux/actions";
import {
  SUBSCRIPTIONS_ALL,
  SUBSCRIPTIONS_CREATE,
  SUBSCRIPTIONS_DELETE,
  SUBSCRIPTIONS_GET,
  SUBSCRIPTIONS_UPDATE
} from "redux/constants/Subscriptions"
import EstService from "services/EstService"

export function* getSubscriptions() {
  yield takeLatest(SUBSCRIPTIONS_ALL, function* () {
    try {
      const subscriptions = yield EstService.getSubscriptions();
      yield put(getAllSubscriptionsSuccess(subscriptions.data));
    } catch (err) {
      console.log(err)
    }
  })
}

export function* getSubscription() {
  yield takeLatest(SUBSCRIPTIONS_GET, function* ({subscriptionId}) {
    try {
      const subscription = yield EstService.getSubscription(subscriptionId);
      yield put(getSubscriptionSuccess(subscription.data));
    } catch (err) {
      console.log(err)
    }
  })
}

export function* createSubscription() {
  yield takeLatest(SUBSCRIPTIONS_CREATE, function* ({data, history}) {
    try {
      const subscription = yield EstService.createSubscription(data);
      yield put(createSubscriptionSuccess(subscription.data));
      history.push(`/app/subscriptions/${subscription.data.id}`);
    } catch (err) {
      console.log(err)
    }
  })
}

export function* updateSubscription() {
  yield takeLatest(SUBSCRIPTIONS_UPDATE, function* ({subscriptionId, data, history}) {
    try {
      const subscription = yield EstService.updateSubscription(subscriptionId, data);
      yield put(updateSubscriptionSuccess(subscriptionId, subscription.data));
      history.push(`/app/subscriptions/${subscriptionId}`);
    } catch (err) {
      console.log(err)
    }
  })
}

export function* deleteSubscription() {
  yield takeLatest(SUBSCRIPTIONS_DELETE, function* ({subscriptionId, history}) {
    try {
      yield EstService.deleteSubscription(subscriptionId);
      yield put(deleteSubscriptionSuccess(subscriptionId));
      history.push(`/app/subscriptions`);
    } catch (err) {
      console.log(err)
    }
  })
}

export default function* subscriptionsSaga() {
  yield all([
    fork(getSubscriptions),
    fork(createSubscription),
    fork(getSubscription),
    fork(updateSubscription),
    fork(deleteSubscription),
  ]);
}